/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { OpenAiGeneratedComponentResponseDto } from '../models/open-ai-generated-component-response-dto';

@Injectable({
  providedIn: 'root',
})
export class AiAssistantCallControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation aiAssistantCallControllerGenerateComponent
   */
  static readonly AiAssistantCallControllerGenerateComponentPath = '/ai-assistant-call/generate-component';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `generateComponent()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  generateComponent$Response(params: {
    secretAPIKey?: string;

    /**
     * Request body for multipart/form-data based file upload
     */
    body: { 'file'?: Blob }
  }): Observable<StrictHttpResponse<OpenAiGeneratedComponentResponseDto>> {

    const rb = new RequestBuilder(this.rootUrl, AiAssistantCallControllerService.AiAssistantCallControllerGenerateComponentPath, 'post');
    if (params) {
      rb.header('secretAPIKey', params.secretAPIKey, {});
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OpenAiGeneratedComponentResponseDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `generateComponent$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  generateComponent(params: {
    secretAPIKey?: string;

    /**
     * Request body for multipart/form-data based file upload
     */
    body: { 'file'?: Blob }
  }): Observable<OpenAiGeneratedComponentResponseDto> {

    return this.generateComponent$Response(params).pipe(
      map((r: StrictHttpResponse<OpenAiGeneratedComponentResponseDto>) => r.body as OpenAiGeneratedComponentResponseDto)
    );
  }

}
